import React from "react"
import ContentSection from "../../../../../../components/Habitacional/ContentSection"
import * as S from "./DocumentPendent.Style"
import { ReactComponent as DocumentIcon } from "../../../../../../assets/images/habitacional/document-pendent.svg";
import { ReactComponent as Alert } from "../../../../../../assets/images/habitacional/alert-icon.svg";
import { ReactComponent as Mail } from "../../../../../../assets/images/habitacional/icon-mail.svg";
import { ReactComponent as Whatsapp } from "../../../../../../assets/images/habitacional/whatsapp-icon-bold.svg";
import Button from "../../../../../../components/Habitacional/core/Button"

const DocumentPendent = ({ comunicatorId }) => {
    return (
        <S.ContainerCompleteFormDFI>
            <ContentSection illustration={<DocumentIcon height="316px" />} title="Tudo certo!" noPadding>
                <S.ContainerTextCompleteFormDFI>
                    <S.DescriptionDataCompleteFormDFI>
                        Guarde o número do pedido para acompanhar o andamento do processo.
                    </S.DescriptionDataCompleteFormDFI>
                </S.ContainerTextCompleteFormDFI>

                <S.ContentNumberCompleteFormDFI>
                    <S.TitleNumberCompleteFormDFI>
                        Número do pedido
                    </S.TitleNumberCompleteFormDFI>
                    <S.NumberCompleteFormDFI>
                        {comunicatorId}
                    </S.NumberCompleteFormDFI>
                </S.ContentNumberCompleteFormDFI>

                <S.Content>
                    <S.TextWithIcon>
                        <S.icon><Alert /></S.icon>
                        <S.MainText>
                            <strong>Atenção:</strong> Você possui documentos pendentes e a nossa análise só começa depois do envio de toda a documentação.
                            Você pode fazer isso aqui pelo site, por e-mail ou no nosso WhatsApp.
                        </S.MainText>
                    </S.TextWithIcon>
                </S.Content>

                <S.ContentButton>
                    <S.TextWithButton>Acompanhe seu pedido ou envie os documentos</S.TextWithButton>
                    <Button variant="primary" type="button">Gerenciar pedido</Button>
                </S.ContentButton>

                <S.ContentLink>
                    <S.TextLink href="mailto:acolhimentohabitacional@caixaseguradora.com.br">
                        <Mail width={25} height={25}/>
                        acolhimentohabitacional@caixaseguradora.com.br
                    </S.TextLink>
                    <S.TextLink href="tel:0800 749 2020">
                        <Whatsapp width={25} height={25}/>
                        WhatsApp: 0800 749 2020
                    </S.TextLink>
                </S.ContentLink>
            </ContentSection>
        </S.ContainerCompleteFormDFI>
    )
}

export default DocumentPendent